<script setup lang="ts">
import { NConfigProvider } from 'naive-ui'
import { NaiveProvider } from '@/components/common'
import { useTheme } from '@/hooks/useTheme'
import { useLanguage } from '@/hooks/useLanguage'
const { theme, themeOverrides } = useTheme()
const { language } = useLanguage()
</script>

<template>
  <NConfigProvider
    class="app-bg"
    :theme="theme"
    :theme-overrides="themeOverrides"
    :locale="language"
  >
    <NaiveProvider>
      <RouterView />
    </NaiveProvider>
  </NConfigProvider>
</template>

<style>
html,
body,
#app {
	height: 100%;
}

.app-bg {
	min-height: var(--app-height, 100vh);
	background: linear-gradient(to bottom, #f7f7f7, #eae4f0) !important;
}

@supports (-webkit-touch-callout: none) {
	.h-screen,
	.h-dvh {
		height: var(--app-height, 100vh) !important;
	}

	.min-h-screen,
	.min-h-dvh {
		min-height: var(--app-height, 100vh) !important;
	}
}
</style>
